<script setup lang="ts">
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  DollarOutlined,
  RiseOutlined,
  TeamOutlined,
} from '@ant-design/icons-vue'
import { ref } from 'vue'

const stats = ref([
  {
    title: 'Total Revenue',
    value: '$12,480',
    change: '+12.5%',
    trend: 'up',
    icon: DollarOutlined,
    color: '#52c41a',
  },
  {
    title: 'Monthly Recurring Revenue',
    value: '$3,840',
    change: '+8.3%',
    trend: 'up',
    icon: RiseOutlined,
    color: '#1677ff',
  },
  {
    title: 'Active Subscriptions',
    value: '128',
    change: '+15.2%',
    trend: 'up',
    icon: TeamOutlined,
    color: '#722ed1',
  },
  {
    title: 'Churn Rate',
    value: '2.1%',
    change: '-0.4%',
    trend: 'down',
    icon: ArrowDownOutlined,
    color: '#eb2f96',
  },
])

const plans = ref([
  { name: 'Starter', subscribers: 64, monthly: '$19', revenue: '$1,216', color: '#1677ff' },
  { name: 'Professional', subscribers: 42, monthly: '$49', revenue: '$2,058', color: '#722ed1' },
  { name: 'Enterprise', subscribers: 22, monthly: '$99', revenue: '$2,178', color: '#eb2f96' },
])

const transactions = ref([
  {
    date: '2026-07-08',
    customer: 'Blue Ocean Resort',
    plan: 'Professional',
    amount: '$49.00',
    status: 'paid',
  },
  {
    date: '2026-07-08',
    customer: 'Mountain Lodge Co.',
    plan: 'Enterprise',
    amount: '$99.00',
    status: 'paid',
  },
  {
    date: '2026-07-07',
    customer: 'Sunset Villas',
    plan: 'Starter',
    amount: '$19.00',
    status: 'paid',
  },
  {
    date: '2026-07-07',
    customer: 'Lakeview Properties',
    plan: 'Professional',
    amount: '$49.00',
    status: 'paid',
  },
  {
    date: '2026-07-06',
    customer: 'Coastal Rentals',
    plan: 'Enterprise',
    amount: '$99.00',
    status: 'pending',
  },
])
</script>

<template>
  <div style="padding: 24px">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px">
      <h2 style="margin: 0">Finances</h2>
      <a-button type="primary" disabled>Manage Billing</a-button>
    </div>

    <a-row :gutter="[16, 16]">
      <a-col v-for="stat in stats" :key="stat.title" :xs="24" :sm="12" :xl="6">
        <a-card :bordered="true">
          <div style="display: flex; justify-content: space-between; align-items: flex-start">
            <div>
              <div style="font-size: 13px; color: rgba(0,0,0,0.45); margin-bottom: 8px">{{ stat.title }}</div>
              <div style="font-size: 28px; font-weight: 600">{{ stat.value }}</div>
              <div
                :style="{
                  fontSize: 13,
                  marginTop: 4,
                  color: stat.trend === 'up' ? '#52c41a' : '#ff4d4f',
                }"
              >
                <component :is="stat.trend === 'up' ? ArrowUpOutlined : ArrowDownOutlined" />
                {{ stat.change }} vs last month
              </div>
            </div>
            <a-avatar :size="48" :style="{ backgroundColor: stat.color }">
              <component :is="stat.icon" style="font-size: 24px" />
            </a-avatar>
          </div>
        </a-card>
      </a-col>
    </a-row>

    <a-row :gutter="[16, 16]" style="margin-top: 24px">
      <a-col :xs="24" :lg="14">
        <a-card title="Subscription Plans">
          <a-table :data-source="plans" :pagination="false" bordered>
            <a-table-column key="name" title="Plan" data-index="name" />
            <a-table-column key="subscribers" title="Subscribers" data-index="subscribers" />
            <a-table-column key="monthly" title="Monthly Price" data-index="monthly" />
            <a-table-column key="revenue" title="Monthly Revenue" data-index="revenue" />
          </a-table>
        </a-card>
      </a-col>
      <a-col :xs="24" :lg="10">
        <a-card title="Recent Transactions">
          <a-list :data-source="transactions" item-layout="horizontal">
            <template #renderItem="{ item }">
              <a-list-item>
                <a-list-item-meta>
                  <template #title>{{ item.customer }}</template>
                  <template #description>{{ item.date }} &middot; {{ item.plan }}</template>
                </a-list-item-meta>
                <div style="text-align: right">
                  <div style="font-weight: 600">{{ item.amount }}</div>
                  <a-tag :color="item.status === 'paid' ? 'green' : 'orange'">
                    {{ item.status }}
                  </a-tag>
                </div>
              </a-list-item>
            </template>
          </a-list>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
